












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IDelegate, ISortParameters } from "@/interfaces";

@Component
export default class TableDelegatesDesktop extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public delegates: IDelegate[] | null;
  @Prop({ required: false, default: false }) public hideRanks: boolean;

  get columns() {
    let columns = [
      {
        label: this.$t("COMMON.RANK"),
        field: "rank",
        type: "number",
        sortFn: this.sortByRank,
        thClass: "start-cell w-32",
        tdClass: "start-cell w-32",
      },
      {
        label: this.$t("WALLET.DELEGATE.USERNAME"),
        field: "username",
        thClass: `${this.hideRanks ? "start-cell" : ""} text-left`,
        tdClass: `${this.hideRanks ? "start-cell" : ""} text-left`,
      },
      {
        label: this.$t("PAGES.DELEGATE_MONITOR.FORGED_BLOCKS"),
        type: "number",
        field: "blocks.produced",
      },
      {
        label: this.$t("WALLET.DELEGATE.TOTAL_FORGED"),
        type: "number",
        field: "forged.total",
      },
      {
        label: this.$t("PAGES.DELEGATE_MONITOR.VOTES"),
        field: "votes",
        type: "number",
        thClass: "end-cell hidden lg:table-cell",
        tdClass: "end-cell hidden lg:table-cell",
      },
    ];
    if (this.hideRanks) {
      columns = columns.splice(1);
    }

    return columns;
  }

  private emitSortChange(params: ISortParameters[]) {
    this.$emit("on-sort-change", params[0]);
  }

  private sortByRank(x: number, y: number) {
    if (x === null) {
      return 1;
    }
    if (y === null) {
      return -1;
    }
    return x < y ? -1 : 1;
  }
}
